<div class="fb-page">

  <!-- ── Header ─────────────────────────────────────────────── -->
  <div class="page-header">
    <div class="page-header-left">
      <span class="material-icons" [ngClass]="platformIconClass">{{ platformIcon }}</span>
      <div>
        <h1 class="page-title">Social Media Comments - {{ platformName }}</h1>
        <div class="page-sub">AI-powered comment monitoring &amp; auto-reply</div>
      </div>
    </div>
    <button class="ph-btn" (click)="loadComments()">
      <span class="material-icons">refresh</span>
      Refresh
    </button>
  </div>

  <!-- ── Stat cards ─────────────────────────────────────────── -->
  <div class="stats-stack">
    <section class="stats-group">
      <div class="stats-group-title">Comment Flow</div>
      <div class="stats-row stats-row-primary">
        <div class="stat-card">
          <span class="stat-icon material-icons">forum</span>
          <div class="stat-body">
            <div class="stat-value">{{ statsLoading ? '...' : stats.total }}</div>
            <div class="stat-label">Total</div>
          </div>
        </div>
        <div class="stat-card stat-new">
          <span class="stat-icon material-icons">mark_chat_unread</span>
          <div class="stat-body">
            <div class="stat-value">{{ statsLoading ? '...' : stats.newCount }}</div>
            <div class="stat-label">New</div>
          </div>
        </div>
        <div class="stat-card stat-processing">
          <span class="stat-icon material-icons">autorenew</span>
          <div class="stat-body">
            <div class="stat-value">{{ statsLoading ? '...' : stats.processing }}</div>
            <div class="stat-label">Processing</div>
          </div>
        </div>
        <div class="stat-card stat-replied">
          <span class="stat-icon material-icons">check_circle</span>
          <div class="stat-body">
            <div class="stat-value">{{ statsLoading ? '...' : stats.replied }}</div>
            <div class="stat-label">Replied</div>
          </div>
        </div>
        <div class="stat-card stat-handoff">
          <span class="stat-icon material-icons">support_agent</span>
          <div class="stat-body">
            <div class="stat-value">{{ statsLoading ? '...' : stats.handedOff }}</div>
            <div class="stat-label">CSR Handoff</div>
          </div>
        </div>
      </div>
    </section>

    <section class="stats-group">
      <div class="stats-group-title">Sentiment Analysis</div>
      <div class="stats-row stats-row-sentiment">
        <div class="stat-card stat-neutral">
          <span class="stat-icon material-icons">sentiment_neutral</span>
          <div class="stat-body">
            <div class="stat-value">{{ statsLoading ? '...' : stats.neutral }}</div>
            <div class="stat-label">Neutral</div>
          </div>
        </div>
        <div class="stat-card stat-positive">
          <span class="stat-icon material-icons">sentiment_satisfied</span>
          <div class="stat-body">
            <div class="stat-value">{{ statsLoading ? '...' : stats.positive }}</div>
            <div class="stat-label">Positive</div>
          </div>
        </div>
        <div class="stat-card stat-negative">
          <span class="stat-icon material-icons">sentiment_dissatisfied</span>
          <div class="stat-body">
            <div class="stat-value">{{ statsLoading ? '...' : stats.negative }}</div>
            <div class="stat-label">Negative</div>
          </div>
        </div>
      </div>
    </section>

    <section class="stats-group">
      <div class="stats-group-title">Comment Nature</div>
      <div class="stats-row stats-row-complaint">
        <div class="stat-card stat-intent">
          <span class="stat-icon material-icons">report_problem</span>
          <div class="stat-body">
            <div class="stat-value">{{ statsLoading ? '...' : stats.complaints }}</div>
            <div class="stat-label">Complaints</div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <div class="trend-strip" *ngIf="stats.topTrends?.length">
    <div class="trend-title">
      <span class="material-icons">trending_up</span>
      Top Trends
    </div>
    <button class="trend-chip" *ngFor="let trend of stats.topTrends" (click)="filterTrend = trend.trendKey; applyFilters()">
      <span>{{ trend.trendTopic }}</span>
      <strong>{{ trend.count }}</strong>
      <small *ngIf="trend.negative">{{ trend.negative }} negative</small>
    </button>
  </div>

  <!-- ── Filters ────────────────────────────────────────────── -->
  <section class="post-overview">
    <div class="post-overview-head">
      <div class="post-overview-title">
        <span class="material-icons">dynamic_feed</span>
        {{ platformName }} {{ platformNoun | titlecase }}
      </div>
      <div class="post-overview-total">{{ postsLoading ? '...' : posts.length }} {{ platformNoun }} tracked</div>
    </div>

    <div class="post-overview-grid" *ngIf="selectedPost; else allPostsSummary">
      <div class="post-main">
        <div class="post-preview" dir="auto">{{ selectedPost.postPreview || selectedPost.postId }}</div>
        <div class="post-meta-line">
          <span>{{ selectedPost.postType || selectedPost.statusType || platformItemName }}</span>
          <span>{{ formatDate(selectedPost.publishedAt || selectedPost.facebookUpdatedAt) }}</span>
          <a *ngIf="selectedPost.permalinkUrl" [href]="selectedPost.permalinkUrl" target="_blank" rel="noopener">Open {{ platformItemName }}</a>
        </div>
      </div>
      <div class="post-metrics">
        <div><strong>{{ selectedPost.commentCount }}</strong><span>Comments</span></div>
        <div><strong>{{ selectedPost.negativeCount }}</strong><span>Negative</span></div>
        <div><strong>{{ selectedPost.handoffCount }}</strong><span>CSR handoff</span></div>
        <div><strong>{{ selectedPost.complaintCount }}</strong><span>Complaints</span></div>
      </div>
    </div>

    <ng-template #allPostsSummary>
      <div class="post-overview-grid">
        <div class="post-main">
          <div class="post-preview">All {{ platformName }} {{ platformNoun }}</div>
          <div class="post-meta-line">
            <span>Use the {{ platformItemName }} filter to review comments, sentiment, intent and handoff volume against a specific {{ platformItemName }}.</span>
          </div>
        </div>
        <div class="post-metrics">
          <div><strong>{{ postsLoading ? '...' : posts.length }}</strong><span>{{ platformNoun | titlecase }}</span></div>
          <div><strong>{{ statsLoading ? '...' : stats.total }}</strong><span>Comments</span></div>
          <div><strong>{{ statsLoading ? '...' : stats.negative }}</strong><span>Negative</span></div>
          <div><strong>{{ statsLoading ? '...' : stats.handedOff }}</strong><span>CSR handoff</span></div>
        </div>
      </div>
    </ng-template>
  </section>

  <div class="filter-bar">
    <select class="ph-input post-filter" [(ngModel)]="filterPostId" aria-label="Filter by post">
      <option value="">All {{ platformNoun | titlecase }}</option>
      <option *ngFor="let post of posts" [value]="post.postId">{{ postOptionLabel(post) }}</option>
    </select>

    <select class="ph-input" [(ngModel)]="filterStatus" aria-label="Filter by status">
      <option value="">All Statuses</option>
      <option value="NEW">New</option>
      <option value="PROCESSING">Processing</option>
      <option value="REPLIED">Replied</option>
      <option value="HANDED_OFF">CSR Handoff</option>
      <option value="FAILED">Failed</option>
      <option value="DRY_RUN_COMPLETED">Dry Run</option>
    </select>

    <select class="ph-input" [(ngModel)]="filterSentiment" aria-label="Filter by sentiment">
      <option value="">All Sentiments</option>
      <option value="POSITIVE">Positive</option>
      <option value="NEUTRAL">Neutral</option>
      <option value="NEGATIVE">Negative</option>
      <option value="UNKNOWN">Unknown</option>
    </select>

    <select class="ph-input" [(ngModel)]="filterIntent" aria-label="Filter by intent">
      <option value="">All Intents</option>
      <option value="COMPLAINT">Complaint</option>
      <option value="STATUS_INQUIRY">Status inquiry</option>
      <option value="GENERAL_QUESTION">Question</option>
      <option value="APPRECIATION">Appreciation</option>
      <option value="ESCALATION_REQUEST">Escalation</option>
      <option value="ABUSE">Abuse</option>
      <option value="SPAM">Spam</option>
      <option value="OFF_TOPIC">Off topic</option>
    </select>

    <select class="ph-input" [(ngModel)]="filterTrend" aria-label="Filter by trend">
      <option value="">All Trends</option>
      <option *ngFor="let trend of stats.topTrends" [value]="trend.trendKey">{{ trend.trendTopic }}</option>
    </select>

    <input class="ph-input" type="date" [(ngModel)]="filterFrom" aria-label="Date from" />
    <span class="filter-sep">to</span>
    <input class="ph-input" type="date" [(ngModel)]="filterTo" aria-label="Date to" />

    <input class="ph-input filter-search" type="text"
           placeholder="Search commenter or message..."
           [(ngModel)]="filterQ"
           (keydown.enter)="applyFilters()" />

    <button class="ph-btn ph-btn-accent" (click)="applyFilters()">
      <span class="material-icons">search</span>
      Search
    </button>
    <button class="ph-btn" (click)="clearFilters()">
      <span class="material-icons">clear</span>
      Clear
    </button>
  </div>

  <!-- ── Table ──────────────────────────────────────────────── -->
  <div class="table-wrap">
    <div *ngIf="loading" class="loading-row">
      <span class="material-icons spin">autorenew</span>
      Loading...</div>

    <div *ngIf="!loading && comments.length === 0" class="empty-row">
      <span class="material-icons">inbox</span>
      No comments found
    </div>

    <table *ngIf="!loading && comments.length > 0" class="fb-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Commenter</th>
          <th>Message</th>
          <th>Sentiment</th>
          <th>Intent</th>
          <th>Trend</th>
          <th>AI Reply</th>
          <th>CSR Reply</th>
          <th>Status</th>
          <th>Received</th>
          <th>Processed</th>
          <th>Retries</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let c of comments; let i = index">
          <tr class="data-row" [class.row-expanded]="expandedId === c.id"
              [class.row-thread-reply]="isThreadReply(c)"
              (click)="toggleExpand(c.id)" (keydown.enter)="toggleExpand(c.id)"
              tabindex="0" role="button" [attr.aria-expanded]="expandedId === c.id">
            <td class="col-num">{{ currentPage * pageSize + i + 1 }}</td>
            <td class="col-name">
              <div class="commenter-name">{{ c.fromName }}</div>
              <div class="commenter-id">{{ c.fromId }}</div>
            </td>
            <td class="col-msg">
              <div class="thread-badge" *ngIf="isThreadReply(c)">
                <span class="material-icons">subdirectory_arrow_right</span>
                Thread reply
              </div>
              <div dir="auto">{{ c.message | slice:0:80 }}{{ c.message.length > 80 ? '...' : '' }}</div>
              <div class="thread-parent-preview" *ngIf="isThreadReply(c)">
                Parent: {{ parentText(c) || c.parentId }}
              </div>
            </td>
            <td class="col-sentiment">
              <span class="sentiment-badge" [ngClass]="'sentiment-' + (c.sentimentLabel || 'unchecked').toLowerCase()">
                {{ sentimentLabel(c.sentimentLabel) }}
              </span>
              <div class="sentiment-score">{{ sentimentScore(c.sentimentScore) }}</div>
            </td>
            <td class="col-intent">
              <span class="intent-badge" [ngClass]="'intent-' + (c.intentLabel || 'unchecked').toLowerCase()">
                {{ intentLabel(c.intentLabel) }}
              </span>
              <div class="sentiment-score">{{ scoreText(c.intentScore) }}</div>
            </td>
            <td class="col-trend">
              <span class="trend-pill">{{ c.trendTopic || '-' }}</span>
            </td>
            <td class="col-reply">
              <span *ngIf="c.reply; else noReply" class="reply-preview">
                {{ c.reply | slice:0:60 }}{{ (c.reply || '').length > 60 ? '...' : '' }}
              </span>
              <ng-template #noReply><span class="no-reply">—</span></ng-template>
            </td>
            <td class="col-reply">
              <span *ngIf="c.csrReplyText; else noCsrReply" class="reply-preview csr-reply-preview">
                {{ c.csrReplyText | slice:0:60 }}{{ (c.csrReplyText || '').length > 60 ? '...' : '' }}
              </span>
              <ng-template #noCsrReply><span class="no-reply">{{ deliveryLabel(c.csrDeliveryStatus, c) }}</span></ng-template>
            </td>
            <td class="col-status">
              <span class="status-badge" [ngClass]="'status-' + c.status.toLowerCase()">
                {{ statusLabel(c.status) }}
              </span>
            </td>
            <td class="col-date">{{ formatDate(c.createdAt) }}</td>
            <td class="col-date">{{ formatDate(c.processedAt) }}</td>
            <td class="col-retry" [class.retry-warn]="c.retryCount > 0">{{ c.retryCount }}</td>
          </tr>
          <tr *ngIf="expandedId === c.id" class="expand-row">
            <td colspan="12">
              <div class="expand-body">
                <div class="expand-col expand-thread" *ngIf="isThreadReply(c)">
                  <div class="expand-label expand-label-thread">
                    <span class="material-icons">forum</span>
                    Conversation
                  </div>
                  <div class="thread-context">
                    <div class="thread-context-item">
                      <div class="thread-context-title">
                        Parent - {{ parentCommenter(c) }}
                      </div>
                      <div class="thread-context-text" dir="auto">
                        {{ parentText(c) || 'Parent comment is not loaded on this page.' }}
                      </div>
                      <div class="thread-context-reply" *ngIf="parentAiReply(c)" dir="auto">
                        AI replied: {{ parentAiReply(c) }}
                      </div>
                    </div>
                    <div class="thread-context-item thread-context-current">
                      <div class="thread-context-title">
                        Current reply - {{ c.fromName }}
                      </div>
                      <div class="thread-context-text" dir="auto">{{ c.message }}</div>
                    </div>
                  </div>
                </div>
                <div class="expand-col">
                  <div class="expand-label">
                    <span class="material-icons">chat_bubble_outline</span>
                    Full Comment
                  </div>
                  <div class="expand-text" dir="auto">{{ c.message }}</div>
                </div>
                <div class="expand-col" *ngIf="c.reply">
                  <div class="expand-label expand-label-reply">
                    <span class="material-icons">smart_toy</span>
                    AI Reply
                  </div>
                  <div class="expand-text expand-text-reply" dir="auto">{{ c.reply }}</div>
                </div>
                <div class="expand-col" *ngIf="c.csrReplyText">
                  <div class="expand-label expand-label-csr-reply">
                    <span class="material-icons">support_agent</span>
                    CSR Reply
                  </div>
                  <div class="expand-text expand-text-csr-reply" dir="auto">{{ c.csrReplyText }}</div>
                  <div class="reply-meta">
                    {{ c.csrReplyBy || 'CSR' }} - {{ formatDate(c.csrRepliedAt) }} - {{ deliveryLabel(c.csrDeliveryStatus, c) }}
                  </div>
                </div>
                <div class="expand-col expand-meta">
                  <div class="meta-row"><span class="meta-key">{{ platformItemName | titlecase }} ID</span><span class="meta-val">{{ c.postId }}</span></div>
                  <div class="meta-row" *ngIf="c.parentId"><span class="meta-key">Parent ID</span><span class="meta-val">{{ c.parentId }}</span></div>
                  <div class="meta-row"><span class="meta-key">Comment ID</span><span class="meta-val">{{ c.commentId }}</span></div>
                  <div class="meta-row"><span class="meta-key">Sentiment</span><span class="meta-val">{{ sentimentLabel(c.sentimentLabel) }} - {{ sentimentScore(c.sentimentScore) }}</span></div>
                  <div class="meta-row"><span class="meta-key">Intent</span><span class="meta-val">{{ intentLabel(c.intentLabel) }} - {{ scoreText(c.intentScore) }}</span></div>
                  <div class="meta-row"><span class="meta-key">Trend</span><span class="meta-val">{{ c.trendTopic || '-' }}</span></div>
                  <div class="meta-row"><span class="meta-key">Assigned</span><span class="meta-val">{{ c.assignedAgentUsername || '-' }}</span></div>
                  <div class="meta-row"><span class="meta-key">Delivery</span><span class="meta-val">{{ deliveryLabel(c.csrDeliveryStatus, c) }}</span></div>
                  <div class="meta-row"><span class="meta-key">Updated</span><span class="meta-val">{{ formatDate(c.updatedAt) }}</span></div>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <!-- ── Pagination ─────────────────────────────────────────── -->
  <div class="pagination-bar" *ngIf="totalElements > 0">
    <span class="pag-info">{{ pageStart }}–{{ pageEnd }} of {{ totalElements }}</span>
    <button class="ph-btn" [disabled]="currentPage === 0" (click)="goToPrev()">
      <span class="material-icons">chevron_left</span>
    </button>
    <span class="pag-page">Page {{ displayPage }} / {{ totalPages }}</span>
    <button class="ph-btn" [disabled]="currentPage >= totalPages - 1" (click)="goToNext()">
      <span class="material-icons">chevron_right</span>
    </button>
  </div>

</div>
